import { ReactNode } from 'react';
import { MESSAGE_STATUS } from 'react-easyrocket';
import { MESSAGE_DESCRIPTION } from 'src/constants';
import { useMessage } from 'src/modules/messages';

export interface UserMessageRequiredProps {
  text: string | ReactNode;
  status: MESSAGE_STATUS;
}

interface UserMessageProps extends UserMessageRequiredProps {
  id: string;
  className?: string;
  isReadIt?: boolean;
}

export const UserMessage = ({ id, status, text }: UserMessageProps) => {
  const { closeMessage } = useMessage();
  return (
    <div
      className="bg-m_bg flex items-center self-center z-[101] transition-all top-[20px] rounded-[10px] px-[20px] py-2.5 text-m_text mt-4 cursor-pointer"
      onClick={() => closeMessage(id)}
      style={{ opacity: '1' }}>
      <div className="w-5">{MESSAGE_DESCRIPTION[status]}</div>
      <div style={{ marginLeft: '14px', wordBreak: 'break-word', width: '100%' }}>{text}</div>
    </div>
  );
};
